import { SETTINGS } from 'constants/api';
import axios from 'utils/axios';

export const getPublicBranding = async () => {
    const result = await axios.get(SETTINGS.v1.fetchPublicBranding);
    return result.data;
};

export const getClientSettings = async () => {
    const result = await axios.get(SETTINGS.v1.fetchClientSettings);
    return result.data;
};

export const updateSettings = async (data = {}) => {
    const result = await axios.put(SETTINGS.v1.updateSettings, data);
    return result.data;
};

export const createOrganisationContact = async (data = {}) => {
    const result = await axios.post(SETTINGS.v1.addOrganisationContact, data);
    return result.data;
};

export const updateDirectLinksStatus = async (data = {}) => {
    const result = await axios.patch(SETTINGS.v1.updateDirectLinksStatus, data);
    return result.data;
};

export const updateDefaultQuizLevel = async (data = {}) => {
    const result = await axios.patch(SETTINGS.v1.updateDefaultQuizLevel, data);
    return result.data;
};

export const updateAutoIncludeCourseReady = async (data = {}) => {
    const result = await axios.patch(SETTINGS.v1.updateAutoIncludeCourseReady, data);
    return result.data;
};

export const updateOrganisationalImage = async (formData) => {
    const result = await axios.put(SETTINGS.v1.updateLogo, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return result.data;
};

export const getSubscriptionList = async (data = {}) => {
    const result = await axios.get(SETTINGS.v1.fetchSubscriptionList, {
        params: data
    });
    return result.data;
};

export const getCurrentSubscription = async (data = {}) => {
    const result = await axios.get(SETTINGS.v1.fetchCurrentSubscription, {
        params: data
    });
    return result.data;
};

export const editNotification = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateNotification, data);
    return result.data;
};

export const editLearnerForm = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateLearnerForm, data);
    return result.data;
};

export const editeEmailTemplate = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateEmailTemplate, data);
    return result.data;
};

export const getEmailTemplates = async () => {
    const result = await axios.get(SETTINGS.v1.fetchEmailTemplates);
    return result.data;
};

export const updateEmailTemplate = async (templateId, data) => {
    const result = await axios.put(`${SETTINGS.v1.fetchEmailTemplates}/${templateId}`, data);
    return result.data;
};

export const previewEmailTemplate = async (templateId, data) => {
    const result = await axios.post(`${SETTINGS.v1.fetchEmailTemplates}/${templateId}/preview`, data);
    return result.data;
};

export const restoreEmailTemplate = async (templateId) => {
    const result = await axios.post(`${SETTINGS.v1.fetchEmailTemplates}/${templateId}/restore`);
    return result.data;
};

export const editAxcelerate = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateAxcelerate, data);
    return result.data;
};

export const editApiEnabled = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateApiEnabled, data);
    return result.data;
};

export const editWisenetEnabled = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateWisenetEnabled, data);
    return result.data;
};

export const editWebhooks = async (data) => {
    const result = await axios.post(SETTINGS.v1.updateWebhooks, data);
    return result.data;
};

export const editThreshold = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateThreshold, data);
    return result.data;
};

export const updateFeatureSettings = async (data) => {
    const result = await axios.put(SETTINGS.v1.updateFeatureSettings, data);
    return result.data;
};
